import useEvent from './event'
import useLocalStorage from './useLocalStorage'
import i18n from '../translations'

import type { AddonCard } from '../types/types'

export default function useAddon() {
  const t = i18n.global.t
  const { send } = useEvent()
  const { user, jwt, stores, isSupportConnection } = useLocalStorage()
  const { flags } = useFeatureFlag()

  const addonsList = computed<AddonCard[]>(() => [
    {
      id: 6,
      slug: 'flyer-generator',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-flyer.png',
      title: t('addons.flyerGenerator.title'),
      description: t('addons.flyerGenerator.description'),
      label: t('addons.flyerGenerator.label'),
      actionButton: {
        text: t('addons.flyerGenerator.buttons.access'),
        style: 'font-bold',
        link: `https://visuals.heypongo.com?source=addons&type=flyer&token=${jwt.value}`
      }
    },
    {
      id: 25,
      slug: 'plv-generator',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-plv.png',
      title: t('addons.plvGenerator.title'),
      description: t('addons.plvGenerator.description'),
      label: t('addons.plvGenerator.label'),
      actionButton: {
        text: t('addons.plvGenerator.buttons.access'),
        style: 'font-bold',
        link: `https://visuals.heypongo.com?source=addons&type=plv&token=${jwt.value}`
      }
    },
    {
      id: 5,
      slug: 'insta-story-generator',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-story-generator.png',
      title: t('addons.instaStoryGenerator.title'),
      description: t('addons.instaStoryGenerator.description'),
      label: t('addons.instaStoryGenerator.label'),
      actionButton: {
        text: t('addons.instaStoryGenerator.buttons.access'),
        style: 'font-bold',
        link: `https://visuals.heypongo.com?source=addons&type=story&token=${jwt.value}`
      }
    },
    {
      id: 28,
      slug: 'scene-creator',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-scene-creator.png',
      title: t('addons.sceneCreator.title'),
      description: t('addons.sceneCreator.description'),
      label: t('addons.instaStoryGenerator.label'),
      actionButton: {
        text: t('addons.sceneCreator.buttons.access'),
        style: 'font-bold',
        link: `https://scene-creator.heypongo.com?source=addons&token=${jwt.value}`
      }
    },
    {
      id: 29,
      slug: 'pro-finder',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-pro-finder.png',
      title: t('addons.proFinder.title'),
      description: t('addons.proFinder.description'),
      label: t('addons.proFinder.label'),
      actionButton: {
        text: t('addons.proFinder.buttons.access'),
        style: 'font-bold',
        link: `https://pro-finder.heypongo.com?source=addons&token=${jwt.value}`
      }
    },
    {
      id: 30,
      slug: 'leaderboard',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-leaderboard.png',
      title: t('addons.leaderboard.title'),
      description: t('addons.leaderboard.description'),
      label: t('addons.leaderboard.label'),
      actionButton: {
        text: t('addons.leaderboard.buttons.access'),
        style: 'font-bold',
        link: `https://leaderboard.heypongo.com?source=addons&token=${jwt.value}`
      }
    },
    {
      id: 31,
      slug: 'calendar-scheduler',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-calendar-scheduler.png',
      title: t('addons.calendarScheduler.title'),
      description: t('addons.calendarScheduler.description'),
      label: t('addons.calendarScheduler.label'),
      actionButton: {
        text: t('addons.calendarScheduler.buttons.access'),
        style: 'font-bold',
        link: `https://calendar.heypongo.com?source=addons&token=${jwt.value}`
      }
    },
    {
      id: 32,
      slug: 'multilinks',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-multilinks.png',
      title: t('addons.multilinks.title'),
      description: t('addons.multilinks.description'),
      label: t('addons.multilinks.label'),
      actionButton: {
        text: t('addons.multilinks.buttons.access'),
        style: 'font-bold',
        link: `https://multilinks.heypongo.com/admin?source=addons&token=${jwt.value}`
      }
    },
    {
      id: 21,
      slug: 'marketing-calendar',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-calendar.png',
      title: t('addons.marketingCalendar.title'),
      description: t('addons.marketingCalendar.description'),
      label: t('addons.marketingCalendar.label'),
      actionButton: {
        text: 'Voir le calendrier',
        style: 'font-bold',
        link: 'https://content.heypongo.com/marketing/Calendrier_Marronnier_2026.pdf'
      }
    },
    {
      id: 27,
      slug: 'campaigns-analyzer',
      isAvailable: true,
      cover: 'https://static.heypongo.com/addons/addon-analyzer.png',
      title: t('addons.campaignsAnalyzer.title'),
      description: t('addons.campaignsAnalyzer.description'),
      label: `${t('addons.campaignsAnalyzer.label.available')}`,
      actionButton: {
        text: t('addons.campaignsAnalyzer.buttons.access'),
        style: 'font-bold',
        link: `https://tools.heypongo.com/campaignsanalyzer/analyzer?source=addons&token=${jwt.value}`
      },
      content: {
        title: t('addons.campaignsAnalyzer.title'),
        description: t('addons.campaignsAnalyzer.description'),
        label: t('addons.campaignsAnalyzer.label.notAvailable'),
        images: [],
        actionButtons: [
          {
            text: t('addons.buttons.notifyOnRelease'),
            link: null,
            slug: 'notifyOnRelease',
            confirmationModalId: 8
          }
        ]
      }
    },
    {
      id: 33,
      slug: 'reward-stock',
      // Disponible uniquement pour le merchant 6930
      isAvailable: user.value.merchant.id === 6930,
      cover: 'https://static.heypongo.com/addons/addon-reward-stock.png',
      title: t('addons.rewardStock.title'),
      description: t('addons.rewardStock.description'),
      label: t('addons.rewardStock.label'),
      actionButton: {
        text: t('addons.rewardStock.buttons.access'),
        style: 'font-bold',
        link: `https://stock.heypongo.com?source=addons&token=${jwt.value}`
      }
    },
    {
      id: 34,
      slug: 'referral',
      isAvailable: flags.value['referral-addon']?.enabled ?? false,
      cover: 'https://static.heypongo.com/addons/addon-referral.png',
      title: t('addons.referral.title'),
      description: t('addons.referral.description'),
      label: t('addons.referral.label'),
      actionButton: {
        text: t('addons.referral.buttons.access'),
        style: 'font-bold',
        link: `https://referral.heypongo.com/admin?token=${jwt.value}`
      }
    }
  ])

  const confirmationModals = [
    {
      id: 0,
      cover: '📣',
      title: t('addons.confirmationModal.0.title'),
      description: t('addons.confirmationModal.0.description'),
      buttonText: t('addons.confirmationModal.0.buttonText')
    },
    {
      id: 1,
      cover: '🚀',
      title: t('addons.confirmationModal.1.title'),
      description: t('addons.confirmationModal.1.description'),
      buttonText: t('addons.confirmationModal.1.buttonText')
    },
    {
      id: 2,
      cover: '🔗',
      title: t('addons.confirmationModal.2.title'),
      description: t('addons.confirmationModal.2.description'),
      buttonText: t('addons.confirmationModal.2.buttonText')
    },
    {
      id: 3,
      cover: '💌',
      title: t('addons.confirmationModal.3.title'),
      description: t('addons.confirmationModal.3.description'),
      buttonText: t('addons.confirmationModal.3.buttonText')
    },
    {
      id: 4,
      cover: '💌',
      title: t('addons.confirmationModal.4.title'),
      description: t('addons.confirmationModal.4.description'),
      buttonText: t('addons.confirmationModal.4.buttonText')
    },
    {
      id: 5,
      cover: '⭐',
      title: t('addons.confirmationModal.5.title'),
      description: t('addons.confirmationModal.5.description'),
      buttonText: t('addons.confirmationModal.5.buttonText')
    },
    {
      id: 6,
      cover: '📞',
      title: t('addons.confirmationModal.6.title'),
      description: t('addons.confirmationModal.6.description'),
      buttonText: t('addons.confirmationModal.6.buttonText')
    },
    {
      id: 7,
      cover: '💌',
      title: t('addons.confirmationModal.7.title'),
      description: t('addons.confirmationModal.7.description'),
      buttonText: t('addons.confirmationModal.7.buttonText')
    },
    {
      id: 8,
      cover: '🔔',
      title: t('addons.confirmationModal.8.title'),
      description: t('addons.confirmationModal.8.description'),
      buttonText: t('addons.confirmationModal.8.buttonText')
    },
    {
      id: 9,
      cover: '📦',
      title: t('addons.confirmationModal.9.title'),
      description: t('addons.confirmationModal.9.description'),
      buttonText: t('addons.confirmationModal.9.buttonText')
    },
    {
      id: 10,
      cover: '🔃',
      title: t('addons.confirmationModal.10.title'),
      description: t('addons.confirmationModal.10.description'),
      buttonText: t('addons.confirmationModal.10.buttonText')
    }
  ]

  const sendEvent = (addonId: number, eventName: string, action?: string) => {
    const storeData = stores.value.map((store) => {
      return {
        id: store.id,
        publicId: store.public_id,
        name: store.name
      }
    })
    const data = {
      user: {
        firstName: user.value.firstname,
        email: user.value.email,
        phone: user.value.phone,
        role: user.value.roleTemplate
      },
      merchant: {
        id: user.value.merchant.id,
        publicId: user.value.merchant.publicId,
        name: user.value.merchant.name,
        slug: user.value.merchant.slug,
        stores: storeData
      },
      addon: {
        ...addonsList.value.find((addon) => addon.id === addonId),
        action: action
      }
    }
    send('segment', eventName, data)
  }

  const availableAddonsForSupportConnection = ['new-visuals-generator']
  const availableAddons = computed<AddonCard[]>(() => {
    return addonsList.value.filter((addon) => {
      if (!addon.isAvailable) return false
      if (availableAddonsForSupportConnection.includes(addon.slug) && !isSupportConnection.value) return false

      return true
    })
  })

  return {
    addonsList,
    availableAddons,
    confirmationModals,
    sendEvent,
    isSupportConnection
  }
}
